<template>
  <ion-page>
    <main-header :back-href="defaultBackHref"></main-header>
    <ion-content>
      <form @submit.prevent="handleSubmit()" @keyup.enter="handleSubmit()">
        <ion-list lines="full">
          <input-box
            :validator="$v.email"
            :error-messages="{
              required: 'Please enter your email.',
              email: 'That email address doesn\'t appear to be valid.'
            }"
            :required="true"
            type="email"
            v-model="email"
            @input="hasErrorUserNotFound = false"
          >
            Your Email
          </input-box>
          <ion-item
            v-if="$v.email.$error && !$v.email.userMustExist"
            color="danger"
          >
            This email does not exist.
            <ion-button
              fill="outline"
              color="light"
              size="small"
              class="ion-margin-start"
              @click="handleWantsToSignUp()"
            >
              Tap here to sign up
            </ion-button>
          </ion-item>
          <input-box
            :validator="$v.password"
            :error-messages="{
              required: 'Please enter your password.'
            }"
            :required="true"
            v-model="password"
            type="password"
          >
            Your Password
          </input-box>
        </ion-list>
        <div class="ion-padding">
          <submit-button :submitting="submitting">Sign In</submit-button>
        </div>
      </form>
      <section class="ion-padding ion-margin">
        <hr class="divider" />
      </section>
      <p class="ion-text-center">
        <ion-button
          size="small"
          fill="clear"
          color="dark"
          @click="handleForgotPassword()"
        >
          I forgot my password
        </ion-button>
      </p>
    </ion-content>
  </ion-page>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";
import ErrorAlert from "@/ErrorAlert";
import submittable from "@/mixins/submittable";

export default {
  title: "Sign In",

  mixins: [submittable],

  data: function() {
    return {
      email: "",
      email2: "",
      password: "",
      hasErrorUserNotFound: false
    };
  },

  methods: {
    ...mapActions("auth", ["signInWithEmail"]),

    async handleSubmit() {
      this.hasErrorUserNotFound = false;

      this.$v.$touch();

      if (!this.$v.$invalid) {
        this.startSubmission();

        let user = await this.signInWithEmail({
          email: this.email,
          password: this.password
        });

        if (user === false) {
          if (this.authError.code === "auth/user-not-found") {
            this.hasErrorUserNotFound = true;
          } else if (this.authError.code === "auth/wrong-password") {
            ErrorAlert("That password is incorrect.");
          } else {
            ErrorAlert(this.authError.message);
          }
          this.completeSubmission();
        } else {
          this.$router.push("/").catch(e => e);
        }
      }
    },

    handleWantsToSignUp() {
      this.$router.push({ name: "Sign Up" });
    },

    handleForgotPassword() {
      this.$router.push({ name: "Forgot Password" });
    }
  },

  computed: {
    ...mapGetters("auth", ["authError"]),

    defaultBackHref() {
      return this.$router.resolve({
        name: "Sign In"
      }).href;
    }
  },

  validations: {
    email: {
      required,
      email,
      userMustExist() {
        return !this.hasErrorUserNotFound;
      }
    },
    password: {
      required
    }
  }
};
</script>
